module.exports = __webpack_public_path__ + "static/media/brainflix-macbook-upload.5e09f485.jpg";